import { useState, ChangeEvent } from "react";
import { InputAdornment, TextField } from "@mui/material";
import { Email } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { updateQrText } from "../../state/mainSlice";

interface Props {
    record(): void
}

const EmailInput = ({ record }: Props) => {
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");

    const constructMailtoLink = (email: string, subject: string, message: string) => {
        let mailto = `mailto:${email || ""}`;
        let params = [];
        
        if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
        if (message) params.push(`body=${encodeURIComponent(message)}`);
    
        return params.length ? `${mailto}?${params.join("&")}` : mailto;
    };
    
    const handleInputChange = (setter: (value: string) => void, value: string) => {
        setter(value);
        const mailtoLink = constructMailtoLink(
            email,
            subject,
            message
        );
        dispatch(updateQrText(mailtoLink));
    };

    const onBlur = (event: any) => {
        record();
      }

    return (
        <>
            <TextField
                variant="outlined"
                value={email}
                onChange={(e) => handleInputChange(setEmail, e.target.value)}
                placeholder="To email"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Email color="primary" />
                        </InputAdornment>
                    ),
                }}
                fullWidth
                margin="normal"
                onBlur={onBlur}
            />
            <TextField
                variant="outlined"
                value={subject}
                onChange={(e) => handleInputChange(setSubject, e.target.value)}
                placeholder="Subject"
                fullWidth
                margin="normal"
            />
            <TextField
                variant="outlined"
                value={message}
                onChange={(e) => handleInputChange(setMessage, e.target.value)}
                placeholder="Message"
                multiline
                rows={4}
                fullWidth
                margin="normal"
            />
        </>
    );
};

export default EmailInput;
